import { makeStyles, Theme } from '@material-ui/core';

export const useGenericStyles = makeStyles((theme: Theme) => ({
  appBar: {
    flexGrow: 1,
    borderBottom: '1px solid #E5E5E5',
  },
  wrapTxt: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  buttonIcon: {
    marginRight: 10,
  },
  errorIcon: {
    color: theme.palette.error.main,
    marginLeft: 10,
  },
  warningIcon: {
    color: theme.palette.warning.main,
    marginLeft: 10,
  },
  successIcon: {
    color: theme.palette.primary.main,
    marginLeft: 10,
  },
  waitingIcon: {
    color: '#335EFF',
    marginLeft: 10,
  },
  errorToast: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.error.main,
    padding: '8px 80px',
    margin: '0 -80px',
  },
  successToast: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    padding: '8px 80px',
    margin: '0 -80px',
  },
  textButton: {
    padding: '0 0 0 0',
    marginRight: '10px',
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 0,
  },
  iconWrapper: {
    width: '112px',
    height: '112px',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
